import React, { useState, useEffect } from 'react';
import api from '../api/client';
import { Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedSection({ sectionId, children }: { sectionId: string, children: React.ReactNode }) {
  const { user } = useAuth();
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  // Жесткая проверка: главный админ по флагу или по email
  const isMainAdmin = user?.isMainAdmin || user?.email === 'admin@hrlama.ru';

  useEffect(() => {
    // Если это главный админ — сразу пускаем, не ждем API
    if (isMainAdmin) {
      setIsUnlocked(true);
      setChecking(false);
      return;
    }

    // Если юзер еще не загрузился — ждем
    if (!user) return;

    const checkProtection = async () => {
      try {
        const res = await api.get('/admin-access/sections');
        const section = res.data.find((s: any) => s.id === sectionId);
        
        if (section && section.requiresPassword === false) {
          setIsUnlocked(true);
        } else {
          setIsUnlocked(false);
        }
      } catch (e) {
        console.error('Ошибка проверки защиты раздела', e);
        setIsUnlocked(false);
      } finally {
        setChecking(false);
      }
    };

    checkProtection();
  }, [user, sectionId, isMainAdmin]);

  const handleUnlock = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/admin-access/verify-password', { password });
      if (res.data.success) {
        setIsUnlocked(true);
      } else {
        setError('Неверный пароль');
      }
    } catch (err) {
      setError('Ошибка сервера');
    }
  };

  if (checking) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Проверка доступа...</div>;

  // Если главный админ или пароль уже введен — показываем контент
  if (isMainAdmin || isUnlocked) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
      <div style={{ background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(20px)', padding: 40, borderRadius: 24, textAlign: 'center', maxWidth: 400, border: '1px solid rgba(0,0,0,0.1)' }}>
        <Lock size={48} color="#ef4444" style={{ marginBottom: 16 }} />
        <h3 style={{ margin: '0 0 10px 0', fontSize: 20 }}>Раздел защищен</h3>
        <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>Введите ваш пароль от системы.</p>
        <form onSubmit={handleUnlock} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Ваш пароль" style={{ padding: '12px 16px', borderRadius: 12, border: '1px solid #cbd5e1' }} autoFocus />
          {error && <div style={{ color: '#ef4444', fontSize: 13 }}>{error}</div>}
          <button type="submit" style={{ background: '#2575fc', color: '#fff', border: 'none', padding: 12, borderRadius: 12, fontWeight: 600, cursor: 'pointer' }}>Подтвердить</button>
        </form>
      </div>
    </div>
  );
}
